import { render, staticRenderFns } from "./HeadBlock.vue?vue&type=template&id=db45f618"
import script from "./HeadBlock.vue?vue&type=script&lang=js"
export * from "./HeadBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports